/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Delete_Confirm_TitleInputs */

const he_account_notifications_delete_confirm_title = /** @type {(inputs: Account_Notifications_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחק התראה?`)
};

const en_account_notifications_delete_confirm_title = /** @type {(inputs: Account_Notifications_Delete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete notification?`)
};

/**
* | output |
* | --- |
* | "Delete notification?" |
*
* @param {Account_Notifications_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_delete_confirm_title = /** @type {((inputs?: Account_Notifications_Delete_Confirm_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Delete_Confirm_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_delete_confirm_title(inputs)
	return en_account_notifications_delete_confirm_title(inputs)
});